import type { Tour } from 'nextstepjs';

// We use the `content` field to pass the i18n key to the custom card component.
// The `title` field is unused since our custom card handles all rendering via i18n.

export const buildTourSteps = (firstProjectId: string | null): Tour[] => {
  const projectBase = firstProjectId ? `/projects/${firstProjectId}` : null;

  const steps: Tour['steps'] = [
    {
      icon: null,
      title: '',
      content: 'welcome',
      showControls: false,
      showSkip: false,
    },
    {
      icon: null,
      title: '',
      content: 'projectList',
      selector: firstProjectId ? '#onboarding-first-project' : '#onboarding-project-list',
      side: 'bottom-left',
      showControls: false,
      showSkip: false,
      pointerPadding: 4,
      pointerRadius: 8,
      ...(projectBase ? { nextRoute: projectBase } : { nextRoute: '/' }),
    },
  ];

  if (projectBase) {
    steps.push(
      {
        icon: null,
        title: '',
        content: 'viewer',
        showControls: false,
        showSkip: false,
        prevRoute: '/',
      },
      {
        icon: null,
        title: '',
        content: 'headerTools',
        selector: '#onboarding-header-tools',
        side: 'bottom-right',
        showControls: false,
        showSkip: false,
        pointerPadding: 4,
        pointerRadius: 8,
      },
      {
        icon: null,
        title: '',
        content: 'layerSidebar',
        selector: '#onboarding-layers-panel',
        side: 'bottom-right',
        showControls: false,
        showSkip: false,
        pointerPadding: 4,
        pointerRadius: 8,
      },
      {
        icon: null,
        title: '',
        content: 'viewerTools',
        selector: '#onboarding-viewer-tools',
        side: 'top',
        showControls: false,
        showSkip: false,
        pointerPadding: 4,
        pointerRadius: 8,
      },
      {
        icon: null,
        title: '',
        content: 'projectSharing',
        selector: '#onboarding-header-tools > button:nth-of-type(2)',
        side: 'bottom-right',
        showControls: false,
        showSkip: false,
        pointerPadding: 4,
        pointerRadius: 8,
      },
      {
        icon: null,
        title: '',
        content: 'projectSettings',
        selector: '#onboarding-header-tools > button:nth-of-type(3)',
        side: 'bottom-right',
        showControls: false,
        showSkip: false,
        pointerPadding: 4,
        pointerRadius: 8,
      },
      {
        icon: null,
        title: '',
        content: 'uploadProcess',
        selector: '#onboarding-header-tools > button:nth-of-type(4)',
        side: 'bottom',
        showControls: false,
        showSkip: false,
        pointerPadding: 4,
        pointerRadius: 8,
      },
      {
        icon: null,
        title: '',
        content: 'supportSignoff',
        showControls: false,
        showSkip: false,
      },
    );
  }

  return [{ tour: 'onboarding', steps }];
};
